// extracted by mini-css-extract-plugin
module.exports = {"duoIconBackground":"#76bb59","jcGrey100":"#f1f3f4","duo":"MfaChooser__duo","push":"MfaChooser__push","totp":"MfaChooser__totp","webauthn":"MfaChooser__webauthn"};